import { Box, Stack } from "@mui/material";
import { FormType } from "@simplyk/common";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
import { useMediaQuery } from "@/common/hooks/useMediaQuery";

type TicketingSummaryLayoutProps = {
  slots: {
    banner?: React.ReactNode;
    organizationLogo: React.ReactNode;
    coreInfo?: React.ReactNode;
    date?: React.ReactNode;
    location?: React.ReactNode;
    campaignTarget?: React.ReactNode;
    description?: React.ReactNode;
    divider?: React.ReactNode;
  };
};

export const TicketingSummaryLayout = ({ slots }: TicketingSummaryLayoutProps) => {
  const { isSmallScreen } = useMediaQuery();
  const { isEmbed } = useFormV2Context(FormType.Ticketing);

  return (
    <Stack width="100%" direction="column" alignItems="flex-start" gap={2}>
      {!isSmallScreen && slots.banner && <Box sx={{ marginBlockEnd: 1, width: "100%" }}>{slots.banner}</Box>}
      {!isSmallScreen ? (
        <Box sx={{ width: "100%", marginBlockStart: slots.banner ? 0 : 3 }}>{slots.organizationLogo}</Box>
      ) : (
        slots.organizationLogo
      )}
      {!isSmallScreen && !isEmbed && slots.divider}
      {isSmallScreen && slots.coreInfo}
      {slots.campaignTarget}
      {!isEmbed && slots.description}
    </Stack>
  );
};
